/* WRLD TAGS · wt-cart-drawer.js (v4, Sept 18 2026): v3 plus the QUICK LOOK (tap the add-on photo or name: big photo,
   arrows through the product photos, name, price, ADD; stays inside the drawer). Jaime: "the idea is for people to see the product".
   Part 1 (unchanged from v1): pushes wt-cart-drawer.css into the UpCart shadow root when that app is on.
   Part 2 (new): the theme's own cart drawer (<cart-drawer id="CartDrawer">) gets
     a) the REWARD LADDER: one bar with two goals, free shipping then "15% off" (the $100 automatic discount),
        a black line that grows with the cart and ends in a plane (the plane is the head of the line, never detached);
     b) "COMPLETE THE SET": the pin that matches the city of the cap in the cart, and the Gift Box, each with one-tap ADD.
   Everything is configured in CFG below. No theme file is edited: the script rewrites the drawer after every render.
   Jaime, Sept 18 2026: "The $100 rung: 15% off plus free shipping" and "adding the gift box"; plane instead of a square,
   "the line is always connected to the airplane, the airplane is the guiding point". */
/* FINDING Sept 18 2026: theme.liquid does NOT load wt-cart-drawer.css as a stylesheet; it only passes the file to this
   script through data-css (for the UpCart shadow root). With UpCart off, nothing applied it to the page. So this script
   now also attaches it to <head> as a normal stylesheet. RULE: never assume wt-cart-drawer.css is on the page by itself. */
(function(){"use strict";var el=document.currentScript||document.querySelector('script[data-css][src*="wt-cart-drawer"]'),href=el&&el.getAttribute("data-css");if(!href)return;if(!document.querySelector('link[href="'+href+'"]')){var lk=document.createElement("link");lk.rel="stylesheet";lk.href=href;lk.id="wt-cart-drawer-link";document.head.appendChild(lk)}var css=null;function apply(){var host=document.getElementById("upCart"),root=host&&host.shadowRoot;if(!root||css===null)return!1;if(root.getElementById("wt-cart-drawer-style"))return!0;var st=document.createElement("style");return st.id="wt-cart-drawer-style",st.textContent=css,root.appendChild(st),!0}function watch(){var host=document.getElementById("upCart");!host||!host.shadowRoot||new MutationObserver(function(){apply()}).observe(host.shadowRoot,{childList:!0})}fetch(href).then(function(r){return r.text()}).then(function(t){if(css=t,apply()){watch();return}var tries=0,timer=setInterval(function(){(apply()||++tries>100)&&(clearInterval(timer),watch())},200),mo=new MutationObserver(function(){apply()&&(mo.disconnect(),clearInterval(timer),watch())});mo.observe(document.documentElement,{childList:!0,subtree:!0})}).catch(function(){})})();

(function () {
  'use strict';

  /* ------------------------------------------------------------------ CONFIG (edit here) */
  var CFG = {
    /* Goal 1: free shipping. The real number is read from the theme's own free shipping bar in the drawer
       ("Spend $X more to reach free shipping"), so it follows the Customize setting. This is only the fallback. */
    freeShipCents: 7000,
    /* Goal 2: the automatic discount. Must exist in Discounts as an AUTOMATIC "15% off orders of $100+". */
    tierCents: 10000,
    tierLabel: '15% off',
    /* Copy. {amount} is replaced with the money still missing. */
    msgToFree: 'Add {amount} more for free shipping',
    msgToTier: 'Free shipping unlocked.|Add {amount} more for ' + '15% off',
    msgDone: 'Free shipping and 15% off unlocked',
    labelStart: '$0',
    labelFree: 'Free shipping',
    labelTier: '15% off',
    /* Add-ons row */
    addonsTitle: 'Complete the set',
    giftHandle: 'gift-box',
    giftSub: 'Matte black box, magnetic closure. Fits 1 cap',
    pinSubMatched: 'Matches the cap in your cart',
    pinSubGeneric: 'A pin for the road',
    /* City words in the cap title -> pin handle. First rule that matches wins. */
    pinRules: [
      [/new york|nyc|brooklyn|manhattan/i, 'nyc-flag-pin'],
      [/miami|\bmia\b|south beach/i, 'flamingo-miami-pin'],
      [/florida|orlando|tampa|\bfll\b|\bmco\b/i, 'florida-orange-pin'],
      [/las vegas|vegas|nevada/i, 'las-vegas-nevada-pin'],
      [/california|los angeles|san francisco|san diego|\bsfo\b|\blax\b|\bsan\b/i, 'california-map-pin'],
      [/texas|houston|dallas|austin|\biah\b|\bdfw\b/i, 'texas-map-pin'],
      [/\busa\b|united states|america/i, 'usa-map-pin']
    ],
    /* When no rule matches (or the matched pin is sold out), the first available of these is offered. */
    pinFallback: ['passport-and-ticket-pin', 'travel-backpack-pin', 'airplane-pin'],
    addLabel: 'Add',
    addingLabel: 'Adding'
  };

  var PLANE = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M21.5 12.4c0-.8-.7-1.4-1.5-1.4h-5.2L9.9 3.5H7.6l2.4 7.5H5.2L3.8 8.7H2l1.2 3.7L2 16.2h1.8L5.2 13.9h4.8L7.6 21.4h2.3l4.9-7.5H20c.8 0 1.5-.6 1.5-1.5z"/></svg>';

  var drawer, cart = null, products = {}, rendering = false, timer = null, lastEvent = 0;

  function money(cents) { return '$' + (Math.max(0, cents) / 100).toFixed(2); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function pct(n) { return Math.max(0, Math.min(100, n)).toFixed(2) + '%'; }

  function freeShipCents() {
    var stored = 0;
    try { stored = parseInt(sessionStorage.getItem('wt-free-ship') || '0', 10); } catch (e) {}
    return stored > 0 ? stored : CFG.freeShipCents;
  }
  /* Learn the real free shipping goal from the theme's bar: "Spend $30.00 more ..." + cart total. */
  function learnFreeShip(bar) {
    if (!bar || !cart || bar.querySelector('[data-wt]')) return; /* only the theme's own fresh text, never ours */
    var txt = bar.textContent || '';
    if (!/spend/i.test(txt) || !/more/i.test(txt)) return;
    var m = txt.match(/\$\s?([\d,]+(?:\.\d{1,2})?)/);
    if (!m) return;
    var remaining = Math.round(parseFloat(m[1].replace(/,/g, '')) * 100);
    if (remaining > 0) { try { sessionStorage.setItem('wt-free-ship', String(remaining + cart.total_price)); } catch (e) {} }
  }

  function renderLadder(scrollable) {
    var bar = scrollable.querySelector('.free-shipping-bar');
    learnFreeShip(bar);
    var free = freeShipCents(), tier = CFG.tierCents, total = cart.total_price, msg;
    if (total < free) msg = CFG.msgToFree.replace('{amount}', money(free - total));
    else if (total < tier) msg = CFG.msgToTier.replace('{amount}', money(tier - total));
    else msg = CFG.msgDone;
    msg = esc(msg).split('|');
    var html =
      '<div class="wt-ladder" data-wt="ladder">' +
        '<div class="wt-ladder__msg">' + (msg.length > 1 ? '<span class="wt-ladder__ok">' + msg[0] + '</span><br>' + msg[1] : msg[0]) + '</div>' +
        '<div class="wt-ladder__track"><div class="wt-ladder__fill" style="width:' + pct(total / tier * 100) + '"><span class="wt-ladder__plane">' + PLANE + '</span></div></div>' +
        '<div class="wt-ladder__labels"><span>' + esc(CFG.labelStart) + '</span><span class="wt-ladder__mid" style="left:' + pct(free / tier * 100) + '">' + esc(CFG.labelFree) + '</span><span>' + esc(CFG.labelTier) + '</span></div>' +
      '</div>';
    var old = scrollable.querySelector('[data-wt="ladder"]');
    if (old) old.remove();
    if (bar) { bar.innerHTML = html; bar.classList.add('wt-ladder-host'); }
    else scrollable.insertAdjacentHTML('afterbegin', html);
  }

  function getProduct(handle) {
    if (products[handle]) return products[handle];
    products[handle] = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return products[handle];
  }
  function inCart(handle) { return cart.items.some(function (i) { return i.handle === handle; }); }
  function isCap(item) { return !/\bpin\b/i.test(item.product_title) && item.handle !== CFG.giftHandle && !/shipping protection/i.test(item.product_title); }

  function pickPin() {
    var caps = cart.items.filter(isCap);
    /* No cap in the cart, or a pin already in it: no pin row. One pin offer per cart, never a second one. */
    if (!caps.length || cart.items.some(function (i) { return /\bpin\b/i.test(i.product_title); })) return Promise.resolve(null);
    var handle = null, matched = false;
    caps.some(function (item) {
      return CFG.pinRules.some(function (rule) {
        if (rule[0].test(item.product_title) && !inCart(rule[1])) { handle = rule[1]; matched = true; return true; }
        return false;
      });
    });
    var tries = (handle ? [handle] : []).concat(CFG.pinFallback.filter(function (h) { return !inCart(h); }));
    return tries.reduce(function (p, h, idx) {
      return p.then(function (found) {
        if (found) return found;
        return getProduct(h).then(function (prod) {
          if (prod && prod.available) { prod.__sub = (idx === 0 && matched) ? CFG.pinSubMatched : CFG.pinSubGeneric; return prod; }
          return null;
        });
      });
    }, Promise.resolve(null));
  }

  function rowHtml(prod, sub) {
    var v = prod.variants.filter(function (x) { return x.available; })[0] || prod.variants[0];
    var img = prod.featured_image ? prod.featured_image.replace(/(\.[a-z]+)(\?.*)?$/i, '$1') + '?width=200' : '';
    products['#' + prod.handle] = prod;
    return '<div class="wt-addon" data-wt-handle="' + esc(prod.handle) + '">' +
      '<button type="button" class="wt-addon__img" data-wt-look="' + esc(prod.handle) + '" aria-label="' + esc(prod.title) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</button>' +
      '<div class="wt-addon__txt"><button type="button" class="wt-addon__name" data-wt-look="' + esc(prod.handle) + '">' + esc(prod.title) + '</button>' +
      '<div class="wt-addon__sub">' + esc(sub) + '</div><div class="wt-addon__price">' + money(v.price) + '</div></div>' +
      '<button type="button" class="wt-addon__btn" data-wt-add="' + v.id + '">' + esc(CFG.addLabel) + '</button></div>';
  }

  function renderAddons(scrollable) {
    var items = scrollable.querySelector('cart-items');
    var old = scrollable.querySelector('[data-wt="addons"]');
    if (!items || !cart.items.filter(isCap).length) { if (old) old.remove(); return; }
    var wantGift = !inCart(CFG.giftHandle);
    Promise.all([pickPin(), wantGift ? getProduct(CFG.giftHandle) : Promise.resolve(null)]).then(function (res) {
      var pin = res[0], gift = res[1] && res[1].available ? res[1] : null;
      var current = scrollable.querySelector('[data-wt="addons"]');
      if (current) current.remove();
      if (!pin && !gift) return;
      var html = '<div class="wt-addons" data-wt="addons"><div class="wt-addons__title">' + esc(CFG.addonsTitle) + '</div>' +
        (pin ? rowHtml(pin, pin.__sub) : '') + (gift ? rowHtml(gift, CFG.giftSub) : '') + '</div>';
      items.insertAdjacentHTML('afterend', html);
    });
  }


  /* ---------------------------------------------------------------- QUICK LOOK (inside the drawer) */
  function imgUrl(src, w) { return src ? src.replace(/(\.[a-z]+)(\?.*)?$/i, '$1') + '?width=' + w : ''; }
  function openLook(handle) {
    var prod = products['#' + handle];
    if (!prod || !drawer) return;
    closeLook();
    var v = prod.variants.filter(function (x) { return x.available; })[0] || prod.variants[0];
    var imgs = (prod.images && prod.images.length ? prod.images : [prod.featured_image]).filter(Boolean).slice(0, 8);
    var slides = imgs.map(function (u, i) { return '<div class="wt-look__slide' + (i ? '' : ' is-on') + '"><img src="' + esc(imgUrl(u, 900)) + '" alt=""></div>'; }).join('');
    var dots = imgs.length > 1 ? '<div class="wt-look__dots">' + imgs.map(function (u, i) { return '<span' + (i ? '' : ' class="is-on"') + '></span>'; }).join('') + '</div>' : '';
    var arrows = imgs.length > 1 ? '<button type="button" class="wt-look__arrow wt-look__arrow--prev" data-wt-nav="-1" aria-label="Previous photo">&#8249;</button><button type="button" class="wt-look__arrow wt-look__arrow--next" data-wt-nav="1" aria-label="Next photo">&#8250;</button>' : '';
    var html = '<div class="wt-look" data-wt="look" data-wt-index="0" data-wt-count="' + imgs.length + '">' +
      '<div class="wt-look__backdrop" data-wt-close></div>' +
      '<div class="wt-look__panel" role="dialog" aria-label="' + esc(prod.title) + '">' +
        '<button type="button" class="wt-look__close" data-wt-close aria-label="Close">&#215;</button>' +
        '<div class="wt-look__stage">' + slides + arrows + '</div>' + dots +
        '<div class="wt-look__info"><div class="wt-look__name">' + esc(prod.title) + '</div><div class="wt-look__price">' + money(v.price) + '</div></div>' +
        '<button type="button" class="wt-look__add" data-wt-add="' + v.id + '">' + esc(CFG.addLabel) + '</button>' +
      '</div></div>';
    var inner = drawer.querySelector('.drawer__inner') || drawer;
    inner.insertAdjacentHTML('beforeend', html);
    requestAnimationFrame(function () { var l = drawer.querySelector('[data-wt="look"]'); if (l) l.classList.add('is-open'); });
  }
  function closeLook() { var l = drawer && drawer.querySelector('[data-wt="look"]'); if (l) l.remove(); }
  function navLook(dir) {
    var l = drawer.querySelector('[data-wt="look"]'); if (!l) return;
    var n = parseInt(l.getAttribute('data-wt-count'), 10), i = parseInt(l.getAttribute('data-wt-index'), 10);
    i = (i + dir + n) % n; l.setAttribute('data-wt-index', String(i));
    l.querySelectorAll('.wt-look__slide').forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
    l.querySelectorAll('.wt-look__dots span').forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
  }
  function bindLookSwipe(l) {
    var x0 = null;
    l.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    l.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) > 40) navLook(dx < 0 ? 1 : -1); }, { passive: true });
  }

  function addToCart(btn) {
    var id = parseInt(btn.getAttribute('data-wt-add'), 10);
    if (!id || btn.disabled) return;
    btn.disabled = true; btn.textContent = CFG.addingLabel;
    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sections } }));
    var cfg = (window.theme && theme.utils && theme.utils.fetchConfig) ? theme.utils.fetchConfig() : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
    cfg.body = JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: sections });
    fetch((window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add.js', cfg)
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status || state.errors) { btn.disabled = false; btn.textContent = CFG.addLabel; return; }
        closeLook();
        if (window.theme && theme.pubsub) theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: state });
        else refresh();
      })
      .catch(function () { btn.disabled = false; btn.textContent = CFG.addLabel; });
  }

  function render() {
    if (!drawer || rendering) return;
    var scrollable = drawer.querySelector('.drawer__panel .drawer__scrollable');
    if (!scrollable || !cart) return;
    rendering = true;
    try {
      if (cart.item_count === 0) { drawer.querySelectorAll('[data-wt]').forEach(function (n) { n.remove(); }); }
      else { renderLadder(scrollable); renderAddons(scrollable); }
    } finally { setTimeout(function () { rendering = false; }, 0); }
  }

  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { cart = c; render(); }).catch(function () {});
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(refresh, 60); }

  function init() {
    drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    drawer.addEventListener('click', function (e) {
      var b = e.target.closest('[data-wt-add]'); if (b) { e.preventDefault(); addToCart(b); return; }
      var k = e.target.closest('[data-wt-look]'); if (k) { e.preventDefault(); openLook(k.getAttribute('data-wt-look')); var l = drawer.querySelector('[data-wt="look"]'); if (l) bindLookSwipe(l); return; }
      var nv = e.target.closest('[data-wt-nav]'); if (nv) { e.preventDefault(); navLook(parseInt(nv.getAttribute('data-wt-nav'), 10)); return; }
      if (e.target.closest('[data-wt-close]')) { e.preventDefault(); closeLook(); }
    });
    document.addEventListener('keyup', function (e) { if (e.key === 'Escape') closeLook(); });
    drawer.addEventListener('drawer:afterHide', closeLook);
    document.addEventListener('cart:updated', function (e) {
      lastEvent = Date.now(); clearTimeout(timer);
      var c = e.detail && e.detail.cart;
      if (c && typeof c.total_price === 'number' && c.items) { cart = c; render(); } else refresh();
    });
    /* The theme replaces #MiniCart's innerHTML on every change: re-run after each render, ignoring our own inserts
       and the render that the cart:updated event already triggered. */
    new MutationObserver(function (muts) {
      if (rendering || Date.now() - lastEvent < 150) return;
      var foreign = muts.some(function (m) {
        var nodes = Array.prototype.slice.call(m.addedNodes).concat(Array.prototype.slice.call(m.removedNodes));
        return nodes.some(function (n) { return n.nodeType === 1 && !n.hasAttribute('data-wt') && !(n.closest && n.closest('[data-wt]')); }) ||
               (m.target.closest && m.target.closest('[data-wt]') === null && nodes.length && nodes.every(function (n) { return n.nodeType !== 1; }));
      });
      if (foreign) schedule();
    }).observe(drawer, { childList: true, subtree: true });
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();